export default "__VITE_ASSET__UOsavgQ3__"